import type { TFunction } from 'i18next';
import type { SelectOption } from './SelectMap';

export function enumOptions<T extends string>(
  entries: Array<{ value: T; labelKey: string }>,
  t: TFunction
): Array<SelectOption<T>> {
  return entries.map((e) => ({
    value: e.value,
    label: t(e.labelKey),
  }));
}
